

export default function AnimatedBackground() {
  return (
    <>
<section className="relative py-24 px-4 sm:px-8 overflow-hidden"   style={{ backgroundColor: "#eec0c8" }}>
  {/* Animated blobs */}
  <div className="absolute -top-32 -left-32 w-[600px] h-[600px] bg-pink-200 opacity-30 rounded-full blur-3xl animate-[blob_20s_infinite] z-0"></div>
  <div className="absolute -bottom-32 -right-32 w-[600px] h-[600px] bg-white opacity-20 rounded-full blur-3xl animate-[blob_25s_infinite] z-0"></div>

  <div className="relative z-10 max-w-4xl mx-auto text-center">
    {/* Hanging Image Style */}
    <div className="relative inline-block mb-8">
      {/* Hanging string */}
      <div className="w-1 h-6 bg-gray-400 absolute top-[-24px] left-1/2 transform -translate-x-1/2 rounded-full"></div>
      {/* Photo */}
      <div className="w-36 h-36 bg-white border-4 border-white shadow-xl rounded-sm overflow-hidden">
        <img
          src={`/profile.jpg`}
          alt="Your profile"
          className="w-full h-full object-cover"
        />
      </div>
    </div>

    {/* Alternating colored headline */}
    <h2 className="text-4xl md:text-5xl font-extrabold mb-6">
      <span className="text-pink-500">נעים</span>{" "}
      <span className="text-white bg-pink-500 px-2 rounded">להכיר</span>{" "}
    </h2>

    <p className="text-lg md:text-xl text-gray-700 mb-8 leading-relaxed">
            <span className="font-semibold" >
  עליי – אפרת.
            <br></br>
ללבוש את הסיפור שלך
            </span>
<br></br>
שמי אפרת גרינהוט, ובמשך 32 שנים הייתי מנהלת בכירה בעולם הבנקאות.  עבדתי עם אנשים, הובלתי תהליכים, קיבלתי החלטות והשפעתי. דווקא מתוך הקריירה הזו הבנתי שמה שאנחנו לובשות הוא לא רק עניין של טעם, אלא דרך לבטא את עצמנו, לעמוד בביטחון מול החיים, ולהמציא את עצמנו מחדש.

היום אני מרצה לסטיילינג לנשים, מתוך רצון להעביר ידע, כלים ותובנות שצברתי. לא רק מהעולם של אופנה, אלא מהחיים עצמם. בהרצאות שלי אני משלבת תבונה פרקטית, רגישות אנושית ונגיעה אסתטית, כדי לעזור לנשים להתחבר לעצמן דרך מה שהן לובשות ולספר את הסיפור שהן רוצות שיראו.

אני מאמינה שסטייל לא נועד להסתיר, הוא נועד לגלות. לא להלביש תבנית, אלא לחשוף אמת אישית.


    </p>

    <a
      href="#contact"
      className="inline-block px-8 py-3 bg-pink-500 hover:bg-pink-600 text-white rounded-full font-semibold transition shadow-md"
    >
      ליצירת קשר
    </a>
  </div>
</section>


    </>
  )
}
